module.exports = __webpack_public_path__ + "img/Shape-arrow.e0aad5fc.svg";